{
    "SidebarMenu_Reporting_Reporting": "Analisi",
    "SidebarMenu_Reporting_Insights": "Approfondimenti",
    "SidebarMenu_Reporting_Presence": "Presenza",
    "SidebarMenu_FastProvisioning_EnterpriseManagement": "Aggiungi azienda aziendale +",
    "SidebarMenu_FastProvisioning_UserManagement": "Gestione degli utenti",
    "SidebarMenu_FastProvisioning_QueueManagement": "Gestione delle code",
    "SidebarMenu_Admin_Devices": "Dispositivi",
    "SidebarMenu_Admin_Agents": "Agenti",
    "SidebarMenu_Admin_Directory": "Elenco",
    "SidebarMenu_Admin_Codes": "Codici",
    "SidebarMenu_Admin_Partitions": "Partizioni",
    "SidebarMenu_Admin_TelephonyServers": "Server di telefonia",
    "SidebarMenu_Admin_CME": "ECM",
    "SidebarMenu_Admin_AppUsers": "Utenti",
    "SidebarMenu_Admin_Recording": "Registrazione",
    "SidebarMenu_Admin_Messages": "Messaggi",
    "SidebarMenu_Admin_Database": "Banca dati",
    "SidebarMenu_StatusTools_Licences": "Licenze",
    "SidebarMenu_StatusTools_Logging": "Registrazione",
    "SidebarMenu_StatusTools_LogManagement": "Gestione dei registri",
    "SidebarMenu_StatusTools_AuditTrail": "Pista di controllo",
    "SidebarMenu_StatusTools_TelephoneModuleStatus": "Stato del modulo TelSys",
    "SidebarMenu_StatusTools_CallControl": "Controllo delle chiamate",
    "SidebarMenu_StatusTools_ServerStatus": "Stato del server",
    "NAME": "SidebarMenu",
    "SidebarMenu_Admin_ClientConfig": "Configurazione del client",
    "SidebarMenu_Admin_CRM_Configuration": "Integrazione CRM",
    "SidebarMenu_Reporting_CXScore": "Punteggio CX",
    "SidebarMenu_Admin_Overview": "Panoramica"
}